import { render } from "./ViStationSection.vue?vue&type=template&id=20f915f4&scoped=true"
import script from "./ViStationSection.vue?vue&type=script&lang=js"
export * from "./ViStationSection.vue?vue&type=script&lang=js"

import "./ViStationSection.vue?vue&type=style&index=0&id=20f915f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-20f915f4"

export default script